import { AxiosError } from 'axios';
import instance from '../config/axios';

export const emptyCartCall = async (accessToken: string) => {
  try {
    const response = await instance({
      url: '/api/v1/cart/delete',
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status;
  } catch (e) {
    console.log('Unable to clear cart', e);
    return (e as AxiosError).response?.status;
  }
};
